export const translations2 = {
  en: {
    submenu: {
      search: "Search",
      account: "Account",
      back: "Back",

      main: [
        // { label: "Home", type: "link", path: "/" },
        {
          label: "My Orders",
          guestLabel: "Login", // 👈 what guest sees
          type: "link",
          path: "/dashboard/listoforders",
          auth: true,
        },
        { label: "Our story", type: "link", path: "/" },
        // { label: "Book a table", type: "link", path: "/bookatable" },
        { label: "Menu", type: "submenu" },
        { label: "Order Online", type: "category" },
        { label: "Contact", type: "scroll", target: "#intro" },
        {
          label: "Admin Login",
          type: "externallink",
          target: "https://adminsaigonstar.netlify.app/",
        },
      ],

      menuChildren: [
        { label: "Lunch", path: "/menu/lunch" },
        { label: "Dinner", path: "/menu/dinner" },
        { label: "Order Online", type: "scroll", target: "#category" },
      ],
    },
  },

  vi: {
    submenu: {
      search: "Tìm kiếm",
      account: "Tài khoản",
      back: "Quay lại",

      main: [
        { label: "Trang chủ", type: "link", path: "/" },
        { label: "Thực đơn", type: "submenu" },
        { label: "Đặt mang đi", type: "link", path: "/menu" },
        { label: "Giới thiệu", type: "link", path: "/#intro" },
      ],

      menuChildren: [
        { label: "Menu", path: "/menu" },
        { label: "Trưa", path: "/menu/lunch" },
        { label: "Tối", path: "/menu/dinner" },
        { label: "Mang đi", path: "/menu/takeaway" },
      ],
    },
  },
};
